import { Link } from "react-router-dom";
import { MediaBox } from "@/components/MediaBox";
import { consecutiveAspectRuns } from "@/lib/consecutiveAspectRuns";
import { GRID } from "@/constants/testIds";

const FORMATS = {
  widescreen: { ratio: "16 / 9", cols: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" },
  vertical: { ratio: "9 / 16", cols: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" },
  square: { ratio: "1 / 1", cols: "grid-cols-2 sm:grid-cols-3" },
  unknown: { ratio: "1 / 1", cols: "grid-cols-2 sm:grid-cols-3" },
};

export const WorkChronologicalGrid = ({ items, startRank, total, searchString }) => (
  <div
    data-testid={GRID.container}
    data-order="chronological"
    role="list"
    aria-label="Films in publication order"
    className="max-w-[1600px] mx-auto px-4 sm:px-8 py-8 sm:py-10 space-y-4 sm:space-y-5"
  >
    {consecutiveAspectRuns(items).map((run) => {
      const format = FORMATS[run.layout];
      return (
        <div
          key={run.items[0].slug}
          role="presentation"
          data-testid={`work-chronological-run-${run.startIndex}`}
          data-layout={run.layout}
          className={`grid grid-flow-row ${format.cols} gap-4 sm:gap-5 items-start`}
        >
          {run.items.map((project, index) => {
            const rank = startRank + run.startIndex + index;
            return (
              <div key={project.slug} role="listitem" aria-posinset={rank} aria-setsize={total} className="min-w-0">
                <Link
                  to={`/film/${project.slug}`}
                  state={{ fromSearch: searchString }}
                  data-testid={GRID.card(project.slug)}
                  data-global-rank={rank}
                  className="group block min-w-0 border border-[#2A2A2A] hover:border-[#CCFF00] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#CCFF00] transition-colors duration-300"
                >
                  <div
                    data-testid={`chronological-frame-${project.slug}`}
                    className="relative w-full bg-[#050505]"
                    style={{ aspectRatio: format.ratio }}
                  >
                    <MediaBox
                      project={project}
                      className="absolute inset-0"
                      fit="contain"
                      priority={run.startIndex + index < 4}
                      testIdPrefix={`chronological-media-${project.slug}`}
                    />
                  </div>
                  <div className="p-2.5 sm:p-3 flex items-center justify-between gap-2 text-[10px] sm:text-xs tracking-widest uppercase text-[#F5F5F0] group-hover:text-[#CCFF00]">
                    <span data-testid={`chronological-title-${project.slug}`} className="truncate">{project.title}</span>
                    <span data-testid={`chronological-year-${project.slug}`} className="text-[#888880] shrink-0">{project.year}</span>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      );
    })}
  </div>
);